/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react'
import { useParams } from 'react-router'
import PropTypes from 'prop-types'

import { messageConstants } from '../_constants'

import { Button } from 'primereact/button'
import { Password } from 'primereact/password'
import { Growl } from 'primereact/growl'
import { userValidation } from '../_validation'
import { useHistory } from 'react-router-dom'
function ResetPasswordComponent({ resetPasswordChange, success, error, resetPasswordValid }) {
  const [inputs, setInputs] = useState({
    newpassword: '',
    cpassword: ''
  })
  const [expired, setExpired] = useState(false)
  const [errors, setErrors] = useState({})
  const { token } = useParams()
  const { newpassword, cpassword } = inputs
  useEffect(() => {
    resetPasswordValid({ resetToken: token })
  }, [resetPasswordValid, token])
  useEffect(() => {
    if (success || error) {
      if (error?.token === '-1') {
        setExpired(true)
      }
      if (errors?.message === 'invalid')
        setInputs({ newpassword: '', cpassword: '' })
    }
    if (error) {
      showSuccessGrowl()
    }
  }, [success, error])
  function onChange(e) {
    const { name, value } = e.target
    setInputs(inputs => ({ ...inputs, [name]: value }))
  }
  const growl = useRef()
  const history = useHistory()
  const showInvalidGrowl = (message) => {
    growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: message })
  }
  const showSuccessGrowl = () => {

    if (error?.message === 'Password changed  successfully') {
      growl.current.show({ severity: messageConstants.sevirity.success, summary: '', detail: error.message })
      setInputs({ newpassword: '', cpassword: '' })
    }
    if (error?.token === '1')
      setTimeout(function () { history.push('/login') }, 3000)

  }
  function handleSubmit(e) {
    e.preventDefault()
    setErrors(userValidation.ResetValidation(newpassword, cpassword))
    if (newpassword !== cpassword) {
      showInvalidGrowl('New Password and Confirm New Password should be same')
    }
    else if (token && newpassword && cpassword) {
      const passwordValidator = require('password-validator')
      const schema = new passwordValidator()
      schema.is().min(8).has().digits().has().letters().has().symbols()
      if (schema.validate(newpassword)) {
        resetPasswordChange({ resetToken: token, newPassword: newpassword })
      } else {
        showInvalidGrowl('The Password should contain at least one alphabet, one special character, and one number')
      }
    }
  }
  return (

    <div className="p-grid login">
      <Growl ref={growl} />
      <div className="p-col-4 login--wrapperLeft">
        <div className="p-col-align-center">
          <h3>WALLSTREET MAPS</h3>
          <p>Administrator</p>
        </div>
      </div>
      <div className="p-col-8 p-col-align-center login--wrapperRight">
        <div className="login--holder">
          {expired && <div className="p-col-12 titleSec">
            <h4 className="m-b-0">{error.message}</h4>
          </div>}
          {!expired && <form name="form">
            <div className="p-col-12 titleSec">
              <h4 className="m-b-0">Reset Password</h4>
            </div>
            <div className="p-col-12">
              <span className="inputHolder">
                <label className="inputHolder--label">New Password  <sup className="inputHolder--required">*</sup></label>
                <Password value={newpassword} name="newpassword" feedback={false} className="login--input m-t-0" placeholder="New Password" onChange={onChange} />
                {errors.newpassword && (
                  <p className='space-danger'>{errors.newpassword}</p>
                )}
              </span>
            </div>
            <div className="p-col-12">
              <span className="inputHolder">
                <label className="inputHolder--label">Confirm New Password  <sup className="inputHolder--required">*</sup></label>
                <Password value={cpassword} name="cpassword" feedback={false} className="login--input m-t-0" placeholder="Confirm New Password" onChange={onChange} />
                {errors.cpassword && (
                  <p className='space-danger'>{errors.cpassword}</p>)}
              </span>
            </div>
            <div className="p-col-12 m-t-10 flexCenterCenter">
              <Button label="Submit" className="p-button-raised p-button-rounded login--actionSec--loginBtn" onClick={handleSubmit} />
            </div>
          </form>}

        </div>
      </div>
    </div>
  )
}
export default ResetPasswordComponent


ResetPasswordComponent.propTypes = {
  resetPasswordChange: PropTypes.func,
  resetPasswordValid: PropTypes.func
}
